// extracted by mini-css-extract-plugin
module.exports = {"solar-60w-B":"B_solar-60w-B__J_Yj_"};